import { styled } from "@mui/styles";
import { Box } from "@mui/material";

export const StyledInput = styled(Box)(({ theme }) => ({
    '& .currency-box-out': {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        width: '50%'
    },
    '& .currency-box-inn-area': {
        border: '1px solid #C1C1C1',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    '& .MuiInputBase-root': {
        borderRadius: 0,
        '& input': {
            color: '#333333',
            textAlign: 'right',
            paddingLeft: '9px',
            marginRight: '-5px',
            fontWeight: 600,
            lineHeight: '24px',
        }
    },
}));
